import YouTubeIframeLoader from 'youtube-iframe';

class Youtube {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-youtube]'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.each((index, scope) => {
			let $scope = $(scope);
			YouTubeIframeLoader.load(this.loadVideo.bind(this, $scope));
		})
	}

	loadVideo($scope, YT) {
		let youtubeId = $scope.data('youtube');

		new YT.Player($scope[0], {
			height: '1080',
			width: '1920',
			videoId: youtubeId,
			playerVars: {
				loop: 1,
				autoplay: 1,
				mute: 1,
				playlist: youtubeId
			},
			events: {
				'onReady' : this.onReady.bind(this)
			}
		});
	}

	onReady(event) {
		event.target.playVideo();
	}
}

export default Youtube;